import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import supabase from '../supabaseClient';
import { LogoSVG } from './ui/FormControls';
import { MasterAlmacenesSection } from './MasterAlmacenesSection';
import { MasterCuentasSection } from './MasterCuentasSection';

// ── Chrome del panel super admin: header propio, sin Nav de tenant ─
export const MasterLayout = ({ currentUser, setLoginUser, setLoginPass, setCurrentUser }) => {
  const navigate = useNavigate();
  const [tab, setTab] = useState("almacenes");

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="text-white px-4 py-3 shadow" style={{ background: "linear-gradient(90deg,#0f172a,#1e3a5f)" }}>
        <div className="flex items-center justify-between max-w-5xl mx-auto">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: "linear-gradient(145deg,#0ea5e9,#0369a1)" }}>
              <LogoSVG size={20} />
            </div>
            <div>
              <h1 className="font-black text-lg leading-tight">Ware<span style={{ color: "#38bdf8" }}>Hause</span><span style={{ color: "#4ade80" }}>Plan</span></h1>
              <p className="text-blue-300 text-xs">Panel Super Admin</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs px-2 py-1 rounded-full font-semibold bg-purple-600">{currentUser?.label}</span>
            <button onClick={async () => { await supabase.auth.signOut({ scope: "local" }); navigate("/app"); setLoginUser(""); setLoginPass(""); setCurrentUser(null); }} className="text-xs text-blue-300 hover:text-white px-2">⏻</button>
          </div>
        </div>
      </div>

      <div className="bg-white border-b px-4 py-2 shadow-sm sticky top-0 z-10">
        <div className="flex gap-2 max-w-5xl mx-auto">
          <button onClick={() => setTab("almacenes")} className={`px-3 py-2 text-xs font-semibold rounded-lg transition-all ${tab === "almacenes" ? "bg-blue-600 text-white shadow" : "bg-white text-gray-600 hover:bg-blue-50 border border-gray-200"}`}>Clientes activos</button>
          <button onClick={() => setTab("cuentas")} className={`px-3 py-2 text-xs font-semibold rounded-lg transition-all ${tab === "cuentas" ? "bg-blue-600 text-white shadow" : "bg-white text-gray-600 hover:bg-blue-50 border border-gray-200"}`}>Cuentas FREE</button>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 py-6">
        {tab === "almacenes" ? <MasterAlmacenesSection /> : <MasterCuentasSection />}
      </div>
    </div>
  );
};
